export default __webpack_public_path__ + "static/media/pattern_1.3bd9c0b2.png";